// Handles I/O/C/X tap buttons on the field products tab.
// POSTs to the field stock update_ranging endpoint and updates button state.
//
// Confirm mode (field:ranging_confirm, cards #3073 / #4031): last visit's value
// arrives as `hint` and shows as a faded ring only -- never pre-selected, so a
// row is only "answered" once the tasker taps it. Tapping the ghost (or any
// value, including the one already showing) always fires the save. With the
// flag off (`confirm` false) behaviour is exactly as before: `current` is
// pre-selected and re-tapping it is a no-op.
import { Controller } from "@hotwired/stimulus"
import { applyRangingState } from "../lib/ranging_status_styles"

export default class extends Controller {
  static targets = ["btn", "detailsPanel"]
  static values  = {
    url:      String,
    response: String,
    current:  String,
    hint:     String,
    confirm:  Boolean
  }

  connect() {
    this._render()
  }

  toggleDetails() {
    this.detailsPanelTarget.classList.toggle("hidden")
    const btn = this.element.querySelector("[data-expand-btn]")
    if (btn) btn.classList.toggle("rotate-180")
  }

  select(event) {
    const value = event.currentTarget.dataset.value
    if (!this.confirmValue && value === this.currentValue) return

    this.currentValue = value
    this._render()
    this._save(value)
  }

  _render() {
    if (!this.currentValue && !(this.confirmValue && this.hintValue)) return

    this.btnTargets.forEach(btn => {
      const value = btn.dataset.value
      const state = value === this.currentValue ? "selected"
                  : (!this.currentValue && this.confirmValue && value === this.hintValue) ? "ghost"
                  : "idle"
      applyRangingState(btn, value, state)
      btn.dataset.baseTitle ??= btn.title
      btn.title = state === "ghost" ? "Last visit – tap to confirm" : btn.dataset.baseTitle
    })
  }

  _save(value) {
    const csrf = document.querySelector("[name='csrf-token']")?.content
    fetch(this.urlValue, {
      method:  "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf },
      body:    JSON.stringify({ value, response_id: this.responseValue })
    }).catch(err => console.error("Stock ranging update failed:", err))
  }
}
